"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useCallback, useEffect } from "react";
import { useBridge } from "@/src/lib/bridge/useBridge";
import { ROUTER_PATH } from "@config/router";

export function TrackInitializer() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { adjustTrackEvent, isInApp } = useBridge();

  const pageViewTrackEvent = useCallback((pathname: string) => {
    switch (pathname) {
      case ROUTER_PATH.ALPHA_PICK:
        return "alphapick_page_view";
      case ROUTER_PATH.MEMBER:
        return "member_page_view";
      default:
        return "page_view";
    }
  }, []);

  useEffect(() => {
    if (!isInApp) {
      return;
    }
    // 1. 拼接完整的 URL 路径
    const url = `${pathname}${searchParams.toString() ? "?" + searchParams.toString() : ""}`;

    // 2. 通过 JS Bridge 传给原生
    adjustTrackEvent({
      eventKey: pageViewTrackEvent(pathname),
      callbackParams: { url },
    });
  }, [pathname, searchParams, pageViewTrackEvent, adjustTrackEvent, isInApp]); // 监听路径和参数的变化

  return null;
}
